module.exports = __webpack_public_path__ + "static/media/barbell-plate-125.a97788b5.png";